"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlData = exports.ViewUrlQuery = exports.UploadUrlQuery = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Asset.Schema';
const AssetType = effect_1.Schema.Literal('public');
const AssetPath = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^[\w/\-_]*$/));
const typeField = effect_1.Schema.propertySignature(AssetType).annotations({
    description: 'Asset type',
});
const pathField = effect_1.Schema.optionalWith(AssetPath, { exact: true }).annotations({
    description: 'Path (subdirectory)',
});
/**
 * Query parameters for generating a signed upload URL.
 */
exports.UploadUrlQuery = effect_1.Schema.Struct({
    fileName: effect_1.Schema.propertySignature(effect_1.Schema.String.pipe(effect_1.Schema.nonEmptyString(), effect_1.Schema.maxLength(100))).annotations({
        description: 'Asset file name. Should be unique; uniqueness is not enforced. Max length 100.',
    }),
    type: typeField,
    path: pathField,
}).annotations({
    identifier: `${exports.NAMESPACE}.UploadUrlQuery`,
});
/**
 * Query parameters for generating a public asset URL.
 *
 * Unlike the upload endpoint, the current Express validation does not limit
 * fileName to 100 characters.
 */
exports.ViewUrlQuery = effect_1.Schema.Struct({
    fileName: effect_1.Schema.propertySignature(effect_1.Schema.String.pipe(effect_1.Schema.nonEmptyString())).annotations({
        description: 'Asset file name',
    }),
    type: typeField,
    path: pathField,
}).annotations({
    identifier: `${exports.NAMESPACE}.ViewUrlQuery`,
});
/**
 * `{ item: url }` as returned today. OTA `GET …/ota/builds/url` and
 * `GET …/ota/builds/upload-url` use the same encoded shape — extract a shared
 * schema when that group is authored (do not import this from Device).
 */
exports.UrlData = effect_1.Schema.Struct({
    item: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({ description: 'Generated asset URL' }),
}).annotations({
    identifier: `${exports.NAMESPACE}.UrlData`,
    description: 'Signed upload URL or public view URL for a static asset',
});
//# sourceMappingURL=schema.js.map